import { Button } from "@boundary/components/button";
import { DialogClose, DialogContent, DialogTitle } from "@boundary/components/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { MouseEvent } from "react";
import styles from "./iconDialog.module.scss";

type IconSize = "default" | "large";

interface IconDialogProps {
  iconSrc: string;
  iconSize?: IconSize;
  title: string;
  pill?: string | null;
  description: string;
  okText?: string;
  onOkClick?: () => void;
}

function DialogIcon({ iconSrc, size }: { iconSrc: string; size: IconSize }) {
  const className = size === "large" ? styles.iconLarge : styles.icon;
  return <img className={className} src={iconSrc} alt="" />;
}

function DialogTitleText({ title }: { title: string }) {
  return <h2 className={styles.title}>{title}</h2>;
}

function DialogPill({ pill }: { pill: string }) {
  return (
    <div className={styles.pill}>
      {pill}
    </div>
  );
}

function DialogDescription({ description }: { description: string }) {
  return <p className={styles.description}>{description}</p>;
}

function DialogButton({
  okText,
  onOkClick
}: {
  okText?: string;
  onOkClick?: () => void;
}) {
  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onOkClick?.();
  };

  return (
    <DialogClose asChild onClick={handleClick}>
      <Button className={styles.button}>{okText ?? "Понятно"}</Button>
    </DialogClose>
  );
}

export function IconDialog({
  iconSrc,
  iconSize = "default",
  title,
  pill,
  description,
  okText,
  onOkClick
}: IconDialogProps) {
  return (
    <DialogContent className={styles.dialogContent}>
      <VisuallyHidden.Root>
        <DialogTitle>{title}</DialogTitle>
      </VisuallyHidden.Root>
      <DialogIcon iconSrc={iconSrc} size={iconSize} />
      <DialogTitleText title={title} />
      {pill && <DialogPill pill={pill} />}
      <DialogDescription description={description} />
      <DialogButton okText={okText} onOkClick={onOkClick} />
    </DialogContent>
  );
}
